import React from "react";
import moment from "moment";

const originalScheduleStyles = {
  backgroundColor: "#A5B6BF",
  progressColor: "#A5B6BF"
};

const revisedScheduleStyles = {
  backgroundColor: "#E53838",
  progressColor: "#0F4DA1"
};

export const taskListHeader = () => {
  return (
    <div className="taskListHeader">
      <div className="taskListYear text-center border-right-0">Years</div>
      <div className="taskListMonth text-center border-top-0 border-right-0">
        Months
      </div>
    </div>
  );
};

export const taskListDateHeader = () => {
  return (
    <div className="taskListHeader">
      <div className="taskListYear text-center border-right-0 milestoneDateYear">
        Years
      </div>
    </div>
  );
};

export const getTasksFromBucketData = data => {
  let tasks = [];
  {
    data &&
      data.map(bucket => {
        tasks.push({
          start: bucket.originalScheduledStartDate
            ? new Date(
                moment(bucket.originalScheduledStartDate).format("YYYY, MM, DD")
              )
            : new Date(),
          end: bucket.originalScheduledFinishDate
            ? new Date(
                moment(bucket.originalScheduledFinishDate).format(
                  "YYYY, MM, DD"
                )
              )
            : new Date(),
          name: bucket.bucketName,
          id: bucket.bucketId,
          progress: 100,
          isDisabled: true,
          status: bucket.bucketStatusDTO.status,
          styles: originalScheduleStyles,
          type: "originalScheduled",
          delayInDays: bucket.bucketStatusDTO.delayInDays
        });

        let revisedProgress = 100;

        // calculate difference between revised schedule end and original schedule end
        const formattedRevisedScheduleFinishDate = moment(
          bucket.revisedScheduledFinishDate
        );
        const formattedOriginalScheduledFinishDate = moment(
          bucket.originalScheduledFinishDate
        );
        const formattedRevisedScheduleStartDate = moment(
          bucket.revisedScheduledStartDate
        );

        let endDatesDiffOriginalRevised = formattedRevisedScheduleFinishDate.diff(
          formattedOriginalScheduledFinishDate,
          "days"
        );

        let revisedScheduledDuration = formattedRevisedScheduleFinishDate.diff(
          formattedRevisedScheduleStartDate,
          "days"
        );

        if (bucket.bucketStatusDTO.delayInDays > 0) {
          revisedProgress =
            100 -
            (100 * endDatesDiffOriginalRevised) / revisedScheduledDuration;
        }

        tasks.push({
          start: bucket.revisedScheduledStartDate
            ? new Date(
                moment(bucket.revisedScheduledStartDate).format("YYYY, MM, DD")
              )
            : new Date(),
          end: bucket.revisedScheduledFinishDate
            ? new Date(
                moment(bucket.revisedScheduledFinishDate).format("YYYY, MM, DD")
              )
            : new Date(),
          name: bucket.bucketName,
          id: bucket.bucketId,
          progress: revisedProgress,
          isDisabled: true,
          status: bucket.bucketStatusDTO.status,
          delayInDays: bucket.bucketStatusDTO.delayInDays,
          styles: revisedScheduleStyles,
          type: "revisedScheduled"
        });
      });
  }
  return tasks;
};

export const taskListTable = data => {
  return (
    <div>
      {data &&
        data.tasks &&
        data.tasks.map(task => (
          <div className="milestonetaskList text-center border-top-0 border-right-0">
            <span>{task.name}</span>
            <br />
            <div className="d-flex justify-content-center">
              <p
                className={`tags badge badge-pill badge-color text-white py-1 px-2
                ${task.status == "DISABLED" ? "badge-secondary" : ""}
                ${task.status == "ON_TRACK" ? "badge-on-track" : ""}
                ${task.status == "COMPLETED" ? "badge-completed" : ""}
                ${
                  task.status == "COMPLETED" && task.delayInDays > 0
                    ? "ml-4"
                    : ""
                }
                ${task.status == "DELAYED" ? "badge-danger ml-4" : ""}
                `}
              >
                {task.status == "ON_TRACK" ? "ON TRACK" : task.status}
              </p>
              {task.delayInDays > 0 ? (
                <div className="delay-icon ml-1 mt-0" />
              ) : (
                ""
              )}
            </div>
          </div>
        ))}
    </div>
  );
};
